import React, { CSSProperties } from 'react';

import { CollapsibleContainerStyled } from './CollapsibleContainer.styles';

export interface ICCProps {
  name: string
  collapsed: boolean;
  transitionDuration: number;

  openHeight?: {
    type: 'height' | 'flex';
    value: number | string;
  }
  
  titleExtra?: React.ReactNode;

  onTitleBarClick?: () => void;
}

export const CollapsibleContainer: React.FC<ICCProps> = ({
  name, collapsed, transitionDuration, openHeight, children, titleExtra, onTitleBarClick
}) => {
  const openStyle = (openHeight!.type === 'flex' ? { flex: openHeight!.value || 1 } : { height: openHeight!.value }) as CSSProperties;
  const collStyle = (openHeight!.type === 'flex' ? { flex: 0 } : { height: 40 }) as CSSProperties;

  return (
    <CollapsibleContainerStyled style={collapsed ? collStyle : openStyle} {...{ collapsed, transitionDuration }}>
      <div className='TitleBar' onClick={onTitleBarClick}>
        <svg className='Collapser' width='30px' height='30px' viewBox="0 0 20 20">
          <circle cx='10px' cy='10px' r='10px' fill='black' />
          <polyline fill='none' stroke='white' strokeWidth='2px' strokeLinecap='round' points='5,8  10,13 15,8' />
        </svg>
        <span>{name}</span>
        { titleExtra ? (
          <div className='Extra'>
            { titleExtra }
          </div>
        ) : null }
      </div>
      <div className='ListArea'>
        {children}
      </div>
    </CollapsibleContainerStyled>
  );
};

CollapsibleContainer.defaultProps = {
  openHeight: {
    type: 'flex',
    value: 1
  }
};